import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    "& > button": {
      marginLeft: 16,
      "&:first-child": {
        marginLeft: 0,
      },
    },
  },
}));
